namespace RedBullMOBILE360.SalesApp {
    export interface AddonForm {
        Category: Serenity.StringEditor;
        NameAr: Serenity.StringEditor;
        NameEn: Serenity.StringEditor;
        IsActive: Serenity.IntegerEditor;
        Price: Serenity.DecimalEditor;
        Benefits: Serenity.StringEditor;
        Validity: Serenity.IntegerEditor;
        BenefitsAr: Serenity.StringEditor;
        Commission: Serenity.DecimalEditor;
        AllowedChannles: Serenity.StringEditor;
        AllowedIdTypes: Serenity.StringEditor;
    }

    export class AddonForm extends Serenity.PrefixedContext {
        static formKey = 'SalesApp.Addon';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!AddonForm.init)  {
                AddonForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DecimalEditor;

                Q.initFormType(AddonForm, [
                    'Category', w0,
                    'NameAr', w0,
                    'NameEn', w0,
                    'IsActive', w1,
                    'Price', w2,
                    'Benefits', w0,
                    'Validity', w1,
                    'BenefitsAr', w0,
                    'Commission', w2,
                    'AllowedChannles', w0,
                    'AllowedIdTypes', w0
                ]);
            }
        }
    }
}
